import { connect } from 'react-redux';
import SmartActionSidePanel from '../../components/smart-action-sidepanel/smart-action-sidepanel';
import {
  saveSmartAction,
  createSmartAction,
  setActionForCreatingOrder,
  fetchSmartAction,
} from './smart-action-sidepanel-actions';

const mapStateToProps = (state) => {
  const {
    ticketForm: { ticket, tags },
    smartAction: { isSaving, success, error, action, isLoadingAction },
    header: { menuVisible },
  } = state;

  return {
    ticket,
    action,
    tags,
    isSaving,
    success,
    error,
    isLoadingAction,
    menuVisible,
  };
};

const mapDispatchToProps = {
  saveSmartAction,
  createSmartAction,
  setActionForCreatingOrder,
  fetchSmartAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SmartActionSidePanel);
